/**
 * Workspaces UI 用ラベル / セレクタ定義（i18n せず日本語直書き、admin-ops 内部 UI のため）。
 * sales_counter 単体前提へ縮退（#1479、カウンターシリーズ4製品構想は2026-07-02撤退）。
 */
import type {
  BillingStatus,
  HealthFilterKey,
  OwnerProductEmailConsent,
  WorkspaceSortKey,
} from '../../lib/workspaces-api';

export const PRODUCT_LABEL = '営業';
export const PRODUCT_LABEL_FULL = '営業受付カウンター';

export const BILLING_STATUS_LABEL: Record<BillingStatus, string> = {
  trialing: 'trial',
  active: 'active',
  past_due: 'past_due',
  canceled: 'canceled',
};

/** #1886: Owner の製品お知らせメールの許可状況。 */
export const PRODUCT_EMAIL_CONSENT_LABEL: Record<OwnerProductEmailConsent, string> = {
  granted: '許可',
  revoked: '取り消し',
  unanswered: '未回答',
};

export const PRODUCT_EMAIL_CONSENT_BADGE: Record<OwnerProductEmailConsent, string> = {
  granted: 'bg-emerald-100 text-emerald-800',
  revoked: 'bg-amber-100 text-amber-800',
  unanswered: 'bg-slate-100 text-slate-600',
};

export const HEALTH_LABEL: Record<HealthFilterKey, string> = {
  past_due: '課金未払い',
  inactive_14d_ai_off: '14日無ログイン + AI OFF',
  trial_no_lead_7d: 'trial × 7d 受信 0',
  no_channel: 'チャネル未接続',
  no_lead_30d: '30d 受信 0',
};

export const SORT_LABEL: Record<WorkspaceSortKey, string> = {
  lastLogin: '最終ログイン',
  createdAt: '作成日',
  leadsLast7d: '7d 受信',
  leadsLast30d: '30d 受信',
};

/** ISO8601 → 「2h 前」「3d 前」風の相対表示 */
export function formatRelative(iso: string | null, now: Date = new Date()): string {
  if (!iso) return '—';
  const ms = now.getTime() - Date.parse(iso);
  if (Number.isNaN(ms) || ms < 0) return '—';
  const sec = Math.floor(ms / 1000);
  if (sec < 60) return `${sec}s 前`;
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min}m 前`;
  const hr = Math.floor(min / 60);
  if (hr < 48) return `${hr}h 前`;
  const day = Math.floor(hr / 24);
  return `${day}d 前`;
}
